import { joint } from '../joint';
import { echo } from '../lib/alert';

/* Регистрация через емайл*/

window.unit.adm = {
	init() {
		console.log('adm init run');
		var sendMail = document.querySelector('button.sendMail');
		console.log('adm, sendMail', sendMail);
		if (sendMail) {
			sendMail.addEventListener("click", () => { unit.adm.chkMail() }, false);
		} else {
		}
	},

	chkMail() {
		var input = document.querySelector('input[name="mail"]');
		console.log('adm, input.value=', input.value);
		var v = encodeURIComponent(input.value);
		joint.getData('?a=reg&v=' + v, (r) => {
			//console.log('r=', r);
			var res = JSON.parse(r);
			var msg = document.querySelector('.adm .msg');
			msg.addEventListener("change", (e) => { unit.adm.sendCode(e) }, false);
			if (!res.err) {
				var sendMail = document.querySelector('button.sendMail');
				sendMail.disabled = true;
				msg.innerHTML = '<p>На указанный адрес электронной почты выслан код доступа, введите его в поле ниже:</p><input name=user-code><button class=code>Отправить</button>';
				var sendCode = msg.querySelector('button.code');
			} else msg.innerHTML = 'Не известный или ошибочный емайл';

		});
	},

	sendCode(msg) {
		var code = document.querySelector('input[name=user-code]').value;
		//console.log(code);
		joint.getData('?a=reg&c=' + code, (r) => {
			//console.log('r=', r);
			var res = JSON.parse(r);
			var msg = document.querySelector('.ways .msg');
			if (!res.err) {
				location.reload();
				return false;
			} else{
				 echo('Ошибка регистрации');
			}

		});
	}
}
